module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921122651_T.a5967913.jpg";